"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const galleryImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587884/img/gallery_forest_creek.png",
  alt: "Lichtdurchfluteter Bachlauf im Soonwald"
}, {
  src: "https://huge-sunbird.10web.cloud/wp-content/uploads/2026/04/mmexport1755441762365.jpg?v=yuky5xmuehs",
  alt: "Wanderpfad im sonnendurchfluteten Wald"
}, {
  src: "https://huge-sunbird.10web.cloud/wp-content/uploads/2026/04/IMG_20260403_171738-scaled.jpg?v=9rbiv8onv79",
  alt: "Tai Chi Training in der Natur"
}, {
  src: "https://huge-sunbird.10web.cloud/wp-content/uploads/2026/04/IMG_20250816_113207-scaled.jpg?v=k8de203fp",
  alt: "Unser helles, naturnahes Studio"
}, {
  src: "https://huge-sunbird.10web.cloud/wp-content/uploads/2026/04/mmexport1756105769431.jpg?v=6e49w5gflmq",
  alt: "Sanft fließendes Wasser im Wald"
}, {
  src: "https://huge-sunbird.10web.cloud/wp-content/uploads/2026/04/IMG_20260118_131418-scaled.jpg?v=hld4j5xivtj",
  alt: "Stille Meditation auf einer Waldlichtung"
}];
export default function PhotoGallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="182504" id="impressionen" className="bg-background py-20 md:py-32">
      <div ref={ref} className={`mx-auto max-w-[980px] px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="mb-16 text-center">
          <h2 className="mb-6 text-4xl font-light tracking-normal text-[#4A5D23] md:text-5xl">
            Impressionen
          </h2>
          
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 md:gap-8">
          {galleryImages.map((img, i) => <div key={i} data-index={i} className="overflow-hidden rounded-none bg-muted/30">
              <AspectRatio ratio={3 / 2}>
                <img src={img.src} alt={img.alt} className="h-full w-full object-cover" />
              </AspectRatio>
            </div>)}
        </div>
      </div>
    </section>;
}